import { combineReducers } from 'redux';
import { statsLeadersRootSaga } from './stats-leaders/sagas';
import { statsLeadersReducer } from './stats-leaders/reducer';

const sagas = [ statsLeadersRootSaga ];
const rootReducer = combineReducers( { statsLeaders: statsLeadersReducer } );

// @ts-expect-error
if ( window.PULSE.app.redux ) {
    // @ts-expect-error
    window.PULSE.app.redux.sagas.statspro.root = sagas;
    // @ts-expect-error
    window.PULSE.app.redux.reducers.statspro.root = rootReducer;
} else {
    // @ts-expect-error
    window.PULSE.app.redux = {
        reducers: {
            statspro: {
                root: rootReducer
            }
        },
        sagas: {
            statspro: {
                root: sagas
            }
        }
    };
}
